export default __webpack_public_path__ + "static/media/egg-2.b8045f99.jpg";